export default __webpack_public_path__ + "static/media/banner-healthcare-comp.5c32a400.jpg";